// src/components/MainPage.jsx
import React from 'react';
import MainImg from '../images/main-img.jpg'
import Card1Img from '../images/setting_8715682.svg'
import Card2Img from '../images/contract_12305058.svg'
import Card3Img from '../images/achievement_17084473.svg'
import CheckImg from '../images/checked_339818.svg'
import JuryImage from '../images/192721015_ebb5e9a9-c897-4996-a1e1-5219ede67436.jpg'
import RegisterIcon from '../images/take-note_6735206.svg';
import WinnersIcon from '../images/winners_8353868.svg';
import OrganizerIcon from '../images/role_8292139.svg';

const nominations = [
  {
    title: 'CMO of the Year',
    desc: 'за исключительное лидерство, влияние на бизнес и трансформацию бренда',
  },
  {
    title: 'Strategic Visionary of the Year',
    desc: 'за дальновидные стратегии, повлиявшие на рост компании',
  },
  {
    title: 'Global Marketing Leader',
    desc: 'за успешное управление маркетингом в международной структуре',
  },
  {
    title: 'Brand Transformation Architect',
    desc: 'за системный ребрендинг или repositioning',
  },
  {
    title: 'Data-Driven Decision Maker',
    desc: 'за внедрение и масштабирование маркетинговой аналитики',
  },
  {
    title: 'CMO Impact Award',
    desc: 'за прямой вклад маркетинга в рост доходов и бизнеса',
  },
  {
    title: 'Cross-Cultural Communication Champion',
    desc: 'за мастерство в локализации и мультикультурной коммуникации',
  },
  {
    title: 'Innovation Catalyst in Marketing',
    desc: 'за внедрение креативных и технологических инноваций',
  },
  {
    title: 'Reputation & Trust Builder',
    desc: 'за управление доверием и репутацией бренда',
  },
  {
    title: 'Sustainability Marketing Leader',
    desc: 'за продвижение ценностей ESG через маркетинг',
  },
  {
    title: 'Team Leadership Excellence',
    desc: 'за развитие сильной, вовлеченной маркетинговой команды',
  },
];

const events = [
  { date: '1 июня – 31 августа', desc: 'Прием заявок' },
  { date: '1 – 10 сентября', desc: 'Технический аудит и формирование лонг-листа' },
  { date: '15 сентября', desc: 'Публикация шорт-листа' },
  { date: '23 – 25 сентября', desc: 'Финальные дебаты жюри' },
  { date: 'Последняя неделя сентября', desc: 'Онлайн-церемония награждения' },
  { date: 'Октябрь', desc: 'Публикация интервью, кейсов и пост-релизов' },
];

  const items = [
    'Четкие критерии оценки и описание категории',
    'Подтверждённые KPI, бизнес-результаты, стратегические решения',
    'Объективные доказательства влияния маркетинга на рост компании, бренда и индустрии в целом',
  ];

  const cards = [
  {
    title: 'Как подать заявку?',
    icon: RegisterIcon,
    items: [
      'Зарегистрируйтесь на платформе премии;',
      'Выберите номинацию (или несколько);',
      'Заполните заявку, прикрепите описание проекта, презентацию, ссылки и KPI;',
      'Получите уведомление о включении в longlist или shortlist;',
      'Пройдите финальную оценку и получите результат в сентябре.',
    ],
  },
  {
    title: 'Что получают победители?',
    icon: WinnersIcon,
    items: [
      'Именной диплом и цифровую медаль победителя;',
      'Право использовать цифровую медаль «Победитель International CMO Summit Awards»;',
      'Публикацию кейса в профессиональных медиа;',
      'Интервью в крупных и профессиональных СМИ;',
      'Приглашение на экспертные мероприятия и CMO-клубы;',
      'Победа официально подтверждает статус кандидата как эксперта международного уровня и может быть использована как документальное подтверждение для подачи в международные ассоциации.',
    ],
  },
  {
    title: 'Организатор',
    icon: OrganizerIcon,
    items: [
      'Украинская Ассоциация Маркетинга (УАМ) — крупнейшая профильная организация Восточной Европы, основанная в 1997 году.',
      'Член ESOMAR и Международной федерации маркетинга,',
      'УАМ организует конференции, исследования, профессиональные курсы и отраслевые премии.',
    ],
  },
];

export default function Home() {
  return (
    <div className="main-page">

      {/* Hero */}
      <section className="hero">
        <div className="hero__image">
          <img src={MainImg} alt="Сцена" />
        </div>
        <div className="hero__content">
          <h1>International Chief Marketing Officer Summit Awards</h1>
    <h2 className="intro-section__heading">
        Международная премия для лидеров маркетинга СНГ, Азии и Европы
      </h2>

      <p className=" intro-section__text--bilingual">
        International Chief Marketing Officer Summit Awards — престижная международная профессиональная премия,
        учрежденная Украинской Ассоциацией Маркетинга (УАМ) в 2019 году.
        Премия вручается за выдающиеся достижения в области стратегического, корпоративного и международного маркетинга,
        признаёт трансформирующую роль маркетологов в развитии брендов, бизнеса и всей индустрии.
      </p>

      <p>
        Премия проводится в онлайн-формате, что делает её доступной для участников из более чем 25 стран,
        включая: Казахстан, Украина, Узбекистан, Армения, Грузия, Азербайджан, Кыргызстан, Турция, ОАЭ,
        Индия, Польша, Чехия, Литва, Германия, Эстония, Молдова, Словакия, Венгрия и др.
      </p>

      <p>
        С момента основания премия стала единственной в регионе высокоселективной международной платформой,
        где профессиональное сообщество Chief Marketing Officer получает официальное
        международное признание, подтверждённое документально, и видимость на уровне индустрии.
      </p>
          <a href="#apply" className="hero__btn">Подать заявку</a>
        </div>
      </section>


    <div className="cards-section">
      {/* Карточка 1: Международное признание */}
      <div className="card">
        <div className="card__icon-wrapper">
          <img src={Card1Img} alt="" className="card__icon" />
        </div>
        <h3 className="card__title">Международное признание и значимость</h3>
        <p className="card__text">
          International CMO Summit Awards — это международная премия, учреждённая Украинской Ассоциацией Маркетинга (УАМ),
          а также признанная рядом авторитетных национальных и международных профессиональных организаций, включая:
        </p>
        <ul className="card__list">
          <li>Украинскую Ассоциацию Маркетинга (УАМ)</li>
          <li>Международную Ассоциацию Маркетологов СНГ</li>
          <li>Международную Ассоциацию Брендинга (IBA Europe)</li>
          <li>ESOMAR (European Society for Opinion and Marketing Research)</li>
          <li>IAA (International Advertising Association)</li>
        </ul>
        <p className="card__text">
          Премия рассматривается как highly selective peer-reviewed award, присуждаемая ограниченному числу
          выдающихся профессионалов по итогам многоступенчатого и анонимного конкурсного отбора.
        </p>
      </div>

      {/* Карточка 2: Критерии отбора и профессиональная верификация */}
      <div className="card">
        <div className="card__icon-wrapper">
          <img src={Card2Img} alt="" className="card__icon" />
        </div>
        <h3 className="card__title">Критерии отбора и профессиональная верификация</h3>
        <p className="card__text">
          Каждая заявка проходит через систему экспертного рецензирования, основанную на заранее опубликованных
          критериях и аудите доказательной базы. Оценка проводится по системе double-blind: члены жюри не знают
          личностей участников, а участники — членов жюри.
        </p>
        <p className="card__text">
          Жюри состоит из международных экспертов, не связанных с номинантами ни профессионально, ни лично,
          что подтверждается подписанием соглашений о неаффилированности и конфиденциальности.
        </p>
        <p className="card__text">
          Финалисты и победители отбираются исключительно на основании «Критерий оценки победителей»
          (смотри раздел “Номинации и критерии оценки”).
        </p>
      </div>

      {/* Карточка 3: Публичность и международное признание победителей */}
      <div className="card">
        <div className="card__icon-wrapper">
          <img src={Card3Img} alt="" className="card__icon" />
        </div>
        <h3 className="card__title">Публичность и международное признание победителей</h3>
        <p className="card__text">
          Победители получают официальное международное признание, которое включает:
        </p>
        <ul className="card__list">
          <li>Публикации в cnews.ru, vc.ru, Forbes, «Обозреватель», «Украинская правда»</li>
          <li>Внесение в публичный реестр на официальном сайте премии</li>
          <li>Распространение через ESOMAR, IAA, The Marketing Society</li>
          <li>Право использовать статус победителя на конференциях, в публикациях и кейс-стади</li>
        </ul>
      </div>
    </div>



    <section className="criteria-section">
      <h2 className="criteria-section__title">
        Критерии и документальное подтверждение
      </h2>

      <div className="criteria-section__grid">
        {items.map((text, i) => (
          <div key={i} className="criteria-card">
            <div className="criteria-card__icon-wrapper">
              <img src={CheckImg} alt="" className="criteria-card__icon" />
            </div>
            <p className="criteria-card__text">{text}</p>
          </div>
        ))}
      </div>

      <div className="criteria-section__footer-text">
        <p>
          Организаторы принимают только документально подтверждённые достижения.
          Каждая заявка проходит двойной аудит: технический и экспертный. Жюри
          рассматривает только профессиональные кейсы с доказанной эффективностью,
          измеримой результативностью и отраслевой значимостью.
        </p>
      </div>
    </section>

    <section className="selection-section">
      <h2 className="selection-section__header">
        Конкурентность и прозрачность
      </h2>

      <p className="selection-section__text">
        Ежегодно на участие в премии подаётся более 300 заявок, однако лишь 11 из них
        удостаиваются победы — уровень отбора составляет менее 3%. Все заявки проходят
        процедуру blind-анонимизации и оцениваются строго в соответствии с критериями,
        изложенными в разделе «Номинации и критерии оценки победителей».
      </p>


      <h3 className="selection-section__subheading">
        Количество наград и география участников
      </h3>

      <p className="selection-section__text">
        Каждый год присуждается 11 индивидуальных наград в разных номинациях. Премия
        присуждается только одному победителю в каждой номинации в год, отбор проводится
        среди топ-менеджеров с подтверждёнными достижениями в маркетинге, что делает конкурс
        чрезвычайно конкурентным и эксклюзивным. Кандидаты подают заявки из 20+ стран,
        охватывая СНГ, Центральную Азию, Восточную Европу и Ближний Восток.
      </p>

      <div className="selection-section__cards">
        <div className="selection-card">
          <h4 className="selection-card__title">Директора по маркетингу</h4>
          <p className="selection-card__text">Профессионалы, отвечающие за стратегическое руководство маркетингом и развитие брендов в компаниях.</p>
        </div>
        <div className="selection-card">
          <h4 className="selection-card__title">VP Marketing</h4>
          <p className="selection-card__text">Вице-президенты по маркетингу, управляющие крупными международными проектами и отделами.</p>
        </div>
        <div className="selection-card">
          <h4 className="selection-card__title">Head of Global/Regional Marketing</h4>
          <p className="selection-card__text">Руководители глобальных и региональных маркетинговых стратегий в компаниях с оборотом от $5 млн.</p>
        </div>
      </div>
    </section>


    <section className="jury-section">
      <div className="jury-section__inner">
        <h2 className="jury-section__title">
          <span className="jury-section__highlight">Жюри International CMO Summit Awards</span>
        </h2>

        <div className="jury-section__grid">
          <div className="jury-section__image-wrapper">
            <img
              src={JuryImage}
              alt="Члены жюри"
              className="jury-section__image"
            />
          </div>

          <div className="jury-section__text">
            <p>
              Жюри <strong>International CMO Summit Awards</strong> — это независимое экспертное сообщество,
              сформированное из признанных международных лидеров в области маркетинга, брендинга, цифровых
              коммуникаций и исследований. В его состав входят CMO транснациональных корпораций, партнёры
              ведущих агентств и профессора глобальных бизнес-школ (INSEAD, LBS, Columbia, IE). Каждый член
              жюри обладает не менее чем пятилетним опытом на C-level, международным признанием, а также
              участием в глобальных форумах и публикациями в HBR, WARC и Journal of Marketing.
            </p>
            <p>
              Отбор победителей осуществляется по системе <em>double-blind</em>: ни судьи не знают личности
              номинантов, ни номинанты — состав жюри. Все эксперты проходят предварительную верификацию
              и подписывают соглашение о неаффилированности и конфиденциальности.
            </p>
            <p>
              Премия открыта к сотрудничеству с профессионалами, формирующими будущее маркетинга.
              Приглашаем CMO, партнёров агентств, исследователей и членов жюри международных конкурсов,
              соответствующих строгим критериям отбора и готовых обеспечить высокий стандарт экспертной оценки.
            </p>

                      <a href="/jurylist" className="hero__btn">Перейти к Жюри</a>
          </div>
        </div>
      </div>
    </section>

   <section id="nominations" className="nominations-section">
      <h2 className="nominations-section__title">Номинации</h2>
      <p className="nominations-section__intro">
        Каждая номинация сопровождается четкими критериями и кейс-ориентированной заявкой:
      </p>
      <div className="nominations-grid">
        {nominations.map(({ title, desc }) => (
          <div key={title} className="nomination-card">
            <h3 className="nomination-card__title">{title}</h3>
            <p className="nomination-card__desc">{desc}</p>
          </div>
        ))}
      </div>
    </section>

    <section className="submission-section">
      <div className="submission-cards">
        {cards.map(({ title, icon, items }) => (
          <div key={title} className="submission-card">
            <div className="submission-card__icon-wrapper">
              <img src={icon} alt="" className="submission-card__icon" />
            </div>
            <h3 className="submission-card__title">{title}</h3>
            <ul className="submission-card__list">
              {items.map((text, i) => (
                <li key={i}>{text}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>


 <section className="timeline-section">
      <h2 className="timeline-section__title">Ключевые даты</h2>
      <div className="timeline-section__grid">
        {events.map(({ date, desc }) => (
          <div key={date} className="timeline-item">
            <div className="timeline-item__date">{date}</div>
            <div className="timeline-item__desc">{desc}</div>
          </div>
        ))}
      </div>
    </section>


    </div>
  );
}
